<script>
import { mapActions } from "pinia";
import { newsStore } from "@/store/newsStore";

export default {
  props: {
    news: {
      type: Object,
    },
  },
  methods: {
    ...mapActions(newsStore, ['updateConsolidatedNewsList']),
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
      class="member-name"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.proposal.publishByMultipleReferred.p1')}}
    <a href="#">{{news.textParams[8]}}
      {{$t('news.template.proposal.publishByMultipleReferred.p2')}}
    </a>
    {{$t('news.template.proposal.publishByMultipleReferred.p3')}}
    {{news.textParams[2]}}
    <router-link
      :to="{name: 'ProposalView', params: {id: news.textParams[3]}}"
    >{{news.textParams[4]}}</router-link>
    {{$t('news.template.proposal.publishByMultipleReferred.p4')}}
    <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}"
    >{{news.textParams[6]}}</router-link>.
    <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}"
    >{{news.textParams[6]}}</router-link>
    {{$t('news.template.proposal.publishByMultipleReferred.p5')}}
    {{news.textParams[2]}}
    {{$t('news.template.proposal.publishByMultipleReferred.p6')}}
    {{news.textParams[9]}}.
    {{$t('news.template.proposal.publishByMultipleReferred.p7')}}
    {{news.textParams[7]}}
    <router-link :to="{name: 'ProposalView', params: {id: news.textParams[3]}}">
      {{$t('news.template.proposal.publishByMultipleReferred.p8')}}
    </router-link>
    {{$t('news.template.proposal.publishByMultipleReferred.p9')}}
  </div>
</template>
